<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()" [strong]="true">
        <ion-icon slot="icon-only" name="close" />
      </ion-button>
    </ion-buttons>
    <ion-title>{{ rehearsal?.performance?.datetime | readableDateTime: 'date' }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  @if (rehearsal && !isLoading) {
    <app-rehearsal-summary [rehearsal]="rehearsal" [showHeader]="false" />

    @if (canEditRehearsal()) {
      <div class="edit-button-container">
        <ion-button (click)="navigateToEdit()" [disabled]="isNavigating" expand="block" color="primary">
          <ion-icon name="create-outline" slot="start" />
          @if (isNavigating) {
            Laden...
          } @else {
            Repetitie bewerken
          }
        </ion-button>
      </div>
    }
  } @else {
    @if (isLoading) {
      <ion-spinner name="crescent" color="primary" />
    } @else {
      <p>Geen repetitie gevonden.</p>
    }
  }
</ion-content>